var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "rgb(88, 106, 218)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.25 4.25c-.69035594 0-1.25-.55964406-1.25-1.25s.55964406-1.25 1.25-1.25 1.25.55964406 1.25 1.25-.55964406 1.25-1.25 1.25zm0 5c-.69035594 0-1.25-.55964406-1.25-1.25s.55964406-1.25 1.25-1.25 1.25.55964406 1.25 1.25-.55964406 1.25-1.25 1.25zm0 5c-.69035594 0-1.25-.5596441-1.25-1.25s.55964406-1.25 1.25-1.25 1.25.5596441 1.25 1.25-.55964406 1.25-1.25 1.25zm3.75-12.25h10c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-10c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1zm0 5h10c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-10c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1zm0 5h10c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1h-10c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.192f061edd39183525b41062a6e2b37e.svg";
export { ForwardRef as ReactComponent };